module.exports = __webpack_public_path__ + "img/OurServiceBank_pic3.20aea1a6.png";